import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AppGeneralStateService } from 'src/app/app-general-state.service';
import { AuthService } from 'src/app/core/services/auth-security/auth.service';
import { InvoiceService } from 'src/app/core/services/data/invoice.service';
import { QuicksearchService } from 'src/app/core/services/data/quicksearch.service';
import { QuickSearchResults } from 'src/app/shared/entities/QuickSearchResults';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-find-by-invoice-number',
  templateUrl: './find-by-invoice-number.component.html',
  styleUrl: './find-by-invoice-number.component.scss',
})
export class FindByInvoiceNumberComponent implements OnInit, OnDestroy {
  inoviceSearchForm: FormGroup;
  invoiceNumberFound: string = '';
  parkerSearchForm: FormGroup;
  companySearchForm: FormGroup;
  urlDomain: string = '';
  currentInvoiceNumber: string = '';
  subInvoiceDetail: Subscription;
  invoiceDetail: QuickSearchResults;
  turnOnSpinner: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private invoiceService: InvoiceService,
    private authService: AuthService,
    private quicksearchService: QuicksearchService,
    private _appGeneralState: AppGeneralStateService,
  ) {
    this.initInvoiceSearchForm();
    this.urlDomain = environment.UrlDomain;
    const newLocal = (this.turnOnSpinner = false);
    this.getInvoiceNumber();

    this._appGeneralState.canChangeLot = false;
  }

  ngOnInit(): void {}

  ngOnDestroy(): void {
    this._appGeneralState.canChangeLot = true;
  }

  initInvoiceSearchForm(): void {
    this.inoviceSearchForm = new FormGroup({
      invoiceNumber: new FormControl('', [Validators.maxLength(32), Validators.required]),
    });
  }

  getInvoiceNumber(): void {
    let invoiceNumber: any = this.route.snapshot.paramMap.get('invoicenumber');

    if (invoiceNumber !== null) {
      this.currentInvoiceNumber = invoiceNumber;
    }
  }

  onSubmitFindInvoice(): void {
    this.invoiceNumberFound = 'abc';
  }

  onNavToViewInvoice(): void {
    window.open('https://dev.acepark.net/Invoice/ReturnPdf/1004/GB01004112410085', '_blank');
  }

  onNavEnableScreen(): void {
    window.location.href = 'http://localhost:4200/adjustmentsHome/GB01004112410085';
  }
}
